import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthBaseStore, SnackbarService } from '@controladad/ng-base';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly auth = inject(AuthBaseStore);
  private readonly snackbar = inject(SnackbarService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 400 && error.error?.code === 45) {
          this.auth.logout(true);
          return throwError(() => error);
        }

        if (error.status === 401) {
          this.auth.logout(true);
        }

        return throwError(() => error);
      })
    );
  }
}